/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonTagsViewModel } from "../types/PersonTagsViewModel.ts";
import { personTagItemViewModelSchema } from "./personTagItemViewModelSchema.ts";

export const personTagsViewModelSchema = z.object({
  personId: z.optional(
    z.number().int().describe("Identificador único da pessoa."),
  ),
  tags: z
    .array(z.lazy(() => personTagItemViewModelSchema))
    .describe("Lista de tags associadas à pessoa.")
    .nullish(),
}) as unknown as ToZod<PersonTagsViewModel>;
